/**
 * Preditiva Gult Premium V2
 * Copyright (c) 2026 Preditiva. Todos os direitos reservados.
 * Tema proprietario - uso exclusivo clientes Preditiva.
 */
/**
 * product-form.js — Custom Element <product-form>
 * Intercepta o submit do formulário de add-to-cart e usa AJAX.
 * Atualiza o cart drawer via Section Rendering API.
 *
 *  product-form.js é responsável apenas pelo submit;
 * product-info.js cuida da seleção de variantes.
 */

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  async onSubmitHandler(event) {
    event.preventDefault();

    if (this.submitButton.disabled) return;

    this.setLoading(true);
    this.clearError();

    const formData = new FormData(this.form);
    const body = {
      id: parseInt(formData.get('id')),
      quantity: parseInt(formData.get('quantity')) || 1,
      sections: this.getSectionsToRender().map((s) => s.section),
    };

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        this.showError(data.description || 'Erro ao adicionar ao carrinho.');
        return;
      }

      // Atualizar cart drawer via Section Rendering API
      if (this.cartDrawer && data.sections) {
        this.cartDrawer.renderContents(data);
      }

      // Publicar evento de atualização do carrinho
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: body.id,
        cartData: data,
      });

      // Anunciar para leitores de tela
      this.announceAddition();

    } catch (error) {
      console.error('[product-form] Erro:', error);
      this.showError('Ocorreu um erro. Tente novamente.');
    } finally {
      this.setLoading(false);
    }
  }

  getSectionsToRender() {
    return [
      { section: 'cart-drawer', selector: '#CartDrawer' },
      { section: 'cart-icon-bubble', selector: '#cart-icon-bubble' },
    ];
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;

    if (isLoading) {
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitButton.classList.add('is-loading');
      this.submitButton.disabled = true;
    } else {
      this.submitButton.removeAttribute('aria-busy');
      this.submitButton.classList.remove('is-loading');

      // Reabilitar apenas se o produto está disponível
      const variant = document.querySelector('input[name="id"]');
      if (variant && variant.dataset.available !== 'false') {
        this.submitButton.disabled = false;
      }
    }
  }

  showError(message) {
    let errorEl = this.querySelector('.product-form__error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'product-form__error';
      errorEl.setAttribute('role', 'alert');
      this.form.insertAdjacentElement('afterend', errorEl);
    }
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  clearError() {
    const errorEl = this.querySelector('.product-form__error');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  announceAddition() {
    const region = document.getElementById('cart-announcements');
    if (region) {
      const productTitle = this.closest('product-info')?.querySelector('h1')?.textContent || 'Produto';
      region.textContent = `${productTitle.trim()} foi adicionado ao carrinho.`;
    }
  }
}

customElements.define('product-form', ProductForm);
